import { passaicConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PassaicPage() {
  return <CityPageTemplate config={passaicConfig} />;
}